export default __webpack_public_path__ + "maps-examples-light-example-thumbnail-480-b8d8bbfc5df355fc84bf96af2100a6e3.webp";